import { render, staticRenderFns } from "./EgiftList.vue?vue&type=template&id=3f29962a&"
import script from "./EgiftList.vue?vue&type=script&lang=js&"
export * from "./EgiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports